/**
 * Legacy-Redirect: /api-tokens → /developer/api-tokens
 *
 * F-R3-6: Die direkte URL /api-tokens lief in einen 404 — die Seite liegt
 * unter /developer/api-tokens (siehe routes/_auth.developer.api-tokens.tsx).
 * Muster wie beim bestehenden Redirect routes/reportings.tsx.
 */
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/api-tokens')({
  beforeLoad: () => {
    throw redirect({ to: '/developer/api-tokens', replace: true })
  },
  component: () => null,
})
